import { BaseMapper } from '../common/BaseMapper'

import {
  RxAPI,
  RxModel,
} from './type'

export class RxMapper extends BaseMapper {
  apiMapper = (rx: RxAPI): RxModel => ({
    id: rx.id,
    date: rx.date,
    image_url: rx.image_url,
    state: rx.state,
    od: {
      sph: rx.od_sph,
      cyl: rx.od_cyl,
      axis: rx.od_axis,
      add: rx.od_add,
      prism: rx.rx_od_prism,
      prism2: rx.rx_od_prism2,
      prism_dir: rx.rx_od_prism_dir,
      prism2_dir: rx.rx_od_prism2_dir,
    },
    os: {
      sph: rx.os_sph,
      cyl: rx.os_cyl,
      axis: rx.os_axis,
      add: rx.os_add,
      prism: rx.rx_os_prism,
      prism2: rx.rx_os_prism2,
      prism_dir: rx.rx_os_prism_dir,
      prism2_dir: rx.rx_os_prism2_dir,
    },
  })

  public static defaultValue: RxModel = {
    id: 0,
    date: '',
    expiration_date: '',
    image_url: '',
    state: '',
    od: {
      sph: 0,
      cyl: 0,
      axis: 0,
      add: 0,
      prism: 0,
      prism2: 0,
      prism_dir: '',
      prism2_dir: '',
    },
    os: {
      sph: 0,
      cyl: 0,
      axis: 0,
      add: 0,
      prism: 0,
      prism2: 0,
      prism_dir: '',
      prism2_dir: '',
    },
  }
}
